'use client';

import { GirlAbout } from '@/components/girl/girl-about';
import { GirlGos } from '@/components/girl/girl-gos';
import { GirlInterview } from '@/components/girl/girl-interview';
import { GirLSlideshow } from '@/components/girl/girl-slideshow';
import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import { GirlTravelCountries } from '@/components/girl/girl-travel-countries';

export const GirlSedcard = ({
  data,
}: {
  data: AttendantSearchSingleResponse;
}) => {
  return (
    <div className='grid grid-cols-1 lg:gap-8'>
      <GirLSlideshow data={data}></GirLSlideshow>
      <GirlAbout data={data}></GirlAbout>
      <GirlGos data={data}></GirlGos>
      <GirlTravelCountries data={data}></GirlTravelCountries>
      <GirlInterview data={data}></GirlInterview>
    </div>
  );
};
